function originalPath (): string {
  return window.location.origin
}
function getQueryPrams (search: string = location.search): any {
  const str = (search || '').replace('?', '')
  const query: { [key: string]: unknown } = {}
  str.split('&').map((item: string) => {
    const [key, value] = item.split('=')
    query[key] = value
    return item
  })
  return query
}
export { originalPath, getQueryPrams }
